import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { hasNoPaidContent as hasNoPaidContentAction } from 'redux/modules/front';

import Ad from 'components/Ad';

import {
  teaseList,
} from 'lib/PaidContent';

import styles from './styles.module.scss';

const mapStateToProps = ({ shared }) => ({
  vertical: shared.vertical,
});

const mapActionsToProps = ({
  hasNoPaidContent: hasNoPaidContentAction,
});

@connect(mapStateToProps, mapActionsToProps)
class PaidContent extends React.Component {
  static propTypes = {
    vertical: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    adLoaded: PropTypes.func,
    adLoadedWithContent: PropTypes.func,
    className: PropTypes.string,
    isMobileOnlyComponent: PropTypes.bool,
    hasNoPaidContent: PropTypes.func.isRequired,
  };

  static defaultProps = {
    className: null,
    adLoaded: () => {},
    adLoadedWithContent: () => {},
    isMobileOnlyComponent: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      adRendered: null,
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillUpdate(_, { adRendered: nextAdRendered }) {
    const { adRendered: prevAdRendered } = this.state;
    if (prevAdRendered !== nextAdRendered && nextAdRendered === false) {
      const { mode, container, placement } = this.taboolaConfig();
      /* eslint-disable no-underscore-dangle */
      window._taboola = window._taboola || [];
      window._taboola.push({
        mode,
        container,
        placement,
        target_type: 'mix',
      });
      /* eslint-enable no-underscore-dangle */
    }
  }

  taboolaConfig = () => {
    const { vertical, type, isMobileOnlyComponent } = this.props;

    if (vertical === 'today') {
      if (type === teaseList.type) {
        return {
          mode: 'thumbnails-b',
          container: 'taboola-homepage-right-rail---bento',
          placement: 'Homepage Right Rail - Bento',
        };
      }

      if (isMobileOnlyComponent) {
        return {
          mode: 'thumbnails-a',
          container: 'taboola-homepage-mobile-thumbnail---bento',
          placement: 'Homepage Mobile Thumbnail - Bento',
        };
      }

      return {
        mode: 'thumbnails-a',
        container: 'taboola-homepage-thumbnail---bento',
        placement: 'Homepage Thumbnail - Bento',
      };
    }

    if (type === teaseList.type) {
      return {
        mode: 'thumbnails-r',
        container: 'taboola-homepage-text-link---bento',
        placement: 'Homepage Text Link - Bento',
      };
    }
    return {
      mode: 'thumbnails-s',
      container: 'taboola-homepage-thumbnail---bento',
      placement: 'Homepage Thumbnail - Bento',
    };
  }

  adHandler = (enigmaAd, { EVENTS }) => {
    const { adLoaded, hasNoPaidContent, adLoadedWithContent } = this.props;

    enigmaAd.on(EVENTS.RENDER, (event) => {
      if (!event) {
        return;
      }

      if (event.empty) {
        hasNoPaidContent(true);
      } else {
        adLoadedWithContent(true);
      }

      adLoaded(true);
      this.setState({ adRendered: !event.empty });
    });
    enigmaAd.render();
  }

  render() {
    const { adRendered } = this.state;
    const { type, className } = this.props;

    let Element = 'article';
    let adSlot = 'nativethreeup';

    if (type === teaseList.type) {
      Element = 'li';
      adSlot = 'nativeultradense';
    }

    return (
      <Element className={className}>
        <Ad
          slot={adSlot}
          handler={this.adHandler}
          refreshInterval={0}
          activeTab={false}
          adClass={styles.nativeAdContainer}
        />
        {!adRendered && (
          <div id={this.taboolaConfig().container} />
        )}
      </Element>
    );
  }
}

export default PaidContent;
